// extracted by mini-css-extract-plugin
export default {"main":"FormMultilineInput_main__D++4q","label":"FormMultilineInput_label__em7ET"};